import classNames from "classnames"
import { FC, useEffect, useState } from "react"
import { DocumentGridStateType } from "../../../@types/documents"
import { DocumentStatusType, DocumentType, IdTableVariant, LoadingStatus } from "../../../@types/enumsGlobal"
import DefaultDocumentsCommandsPanelV3 from "../../../components/commandsPanels/DefaultDocumentsCommandsPanelV3"
import { DefaultGrid } from "../../../components/grids/default/defaultGrid"
import { PluginWrapper, ToolbarWrapper } from "../../../components/plugins"
import { IOption } from "../../../components/selects/select"
import { Spinner } from "../../../components/spiner/Spinner"
import { TabsPanel } from "../../../components/tabs"
import { IRequestForMovementViewDTO } from "../../../libs/coreapi-dto/documents/requestForMovement"
import tabsStyles from "../../../pages/styles/homePage.module.scss"
import { RequestForMovementDataProvider } from "../../../Services/DataProviders/RequestForMovementDataProvider"
import useGridFilter from "../../../system/hooks/useGridFilter"
import { useDetailsTabsPanel } from "../../../system/hooks/useTabsPanel"
import { useAppContext } from "../../../system/providers/appContextProvider"
import { usePluginContext } from "../../../system/providers/plugin"
import { useTabsContext } from "../../../system/providers/tabsProvider"
import { useUserContext } from "../../../system/providers/userContextProvider"
import { checkAccessStatus } from "../../CommonHelperFunctions"
import { UserActionLogModal } from "../../Service/UserActionLog/view/UserActionLogModal"
import styles from "../../styles/index.module.scss"
import { RequestState } from "../../../@types/enumsGlobal"
import { RequestForMovementGridFilter } from "../../../system/hooks/useGridFilter"
import { User2ContractorDataProvider } from "../../../Services/DataProviders/User2ContractorDataProvider"
import { IUser2ContractorViewDTO } from "../../../libs/coreapi-dto/dirs/user2Contractor"
import { ISaveFocus } from "../../../@types/documents"

export const RequestForMovementPluginView: FC<IGridProps> = (props) => {
    const appCtx = useAppContext();
    const appContext = useAppContext()
    const pluginCtx = usePluginContext()
    const tabCtx = useTabsContext()
    const userContext = useUserContext()
    const requestForMovementDP = new RequestForMovementDataProvider(appContext.coreApiService)
    const user2ContractorDataProvider = new User2ContractorDataProvider(appCtx.coreApiService);
    const [data, setData] = useState<IRequestForMovementViewDTO[]>([])
    const [totalCount, setTotalCount] = useState<number>(0)
    const [selectedItem, setSelectedItem] = useState<IGridRow>()
    const [selectedItems, setSelectedItems] = useState<IGridRow[]>([])
    const [multipleSelect, setMultipleSelect] = useState<boolean>(false)
    const [gridFilter, dispatchGridFilter] = useGridFilter(RequestForMovementGridFilter());
    const [viewState, setViewState] = useState<DocumentGridStateType>("view")
    const [detailsTabsPanel, dispatchDetailsTabsPanel] = useDetailsTabsPanel(props.plugin.mnemocode)
    const defaultSearchOptions = [
        { displayName: "ТН (рус)", value: "tradeName" },
        { displayName: "МНН (рус)", value: "mnn" },
    ] as IOption[]
    const [documentStatusType, setDocumentStatusType] = useState<DocumentStatusType | undefined>()
    const [selectedDocumentState, setSelectedDocumentState] = useState<DocumentStatusType | undefined>()
    const [showDetailsTabs, setShowDetailsTabs] = useState<boolean>(false)
    const [, setLoadingStatus] = useState<LoadingStatus>()
    const [isSubmitting, setIsSubmitting] = useState<boolean>(true)
    const [selectedItemView, setSelectedItemView] = useState<IRequestForMovementViewDTO>()
    const [showModalLog, setShowModalLog] = useState<boolean>(false)
    const [requestState, setRequestState] = useState<RequestState | undefined>();
    const isAdmin = useState<boolean>(userContext.userRoles.includes("Administrator"))[0];
    const [gridFilterContractors] = useGridFilter();
    const [contractors, setContractors] = useState<IUser2ContractorViewDTO[]>([]);

    const [saveFocus, setSaveFocus] = useState<ISaveFocus>({
            viewState: 'view',
            selectedItem: selectedItem,
            data: data
        });
 
    useEffect(() => {
        setIsSubmitting(true)
        requestForMovementDP.getViewParam(gridFilter, async (data, totalCount) => {
            setData(data)
            setTotalCount(totalCount)
            setLoadingStatus(LoadingStatus.Completed)
            setIsSubmitting(false)
        })
    }, [gridFilter])

    const handleRequestStateChange = (newState: RequestState | undefined) => {
        setRequestState(newState);
        dispatchGridFilter({
            type: "updateRequestState",
            payload: newState
        });
    };

    useEffect(() => {
        if (viewState === "refresh") {
            setIsSubmitting(true)
            requestForMovementDP.getViewParam(gridFilter, async (data, totalCount) => {
                setData(data)
                setTotalCount(totalCount)
                setLoadingStatus(LoadingStatus.Completed)
                setViewState("view")
                setIsSubmitting(false)
            })
        }
    }, [viewState])

    useEffect(() => {
        if (!multipleSelect) {
            setSelectedItems([])
        } else {
            setSelectedItem(undefined)
        }
        if (selectedItem) {
            const documentState = selectedItem.cells.find((c) => c.propertyName === "documentState")?.value as DocumentStatusType
            setSelectedDocumentState(documentState ?? undefined)
            setSelectedItemView(data.find((x) => x.idGlobal === selectedItem.idGlobal))
        } else {
            setSelectedItemView(undefined)
        }
    }, [multipleSelect, selectedItem])

    useEffect(() => {
        pluginCtx.masterGrid.onUnselectEvent()
        setShowDetailsTabs(true)
    }, [tabCtx.currentTab])

    useEffect(() => {
        getContractors()
    }, []);

    function getContractors() {

        const userContractorsFilter = {
            ...gridFilterContractors,
            columnFilters: [
                {
                    name: "idUserGlobal",
                    operator: 'Eq',
                    value: userContext.idGlobal
                }
            ]
        } as IGridFilter;

        if (isAdmin) {
            return
        } else {
            user2ContractorDataProvider.getView(userContractorsFilter, (values) => {
                setContractors(values)
            })
        }
    }

    const filterOneItem = {
        numberPerPage: 1,
        pageNumber: 1,
        columnFilters: [
            {
                name: "IdGlobal",
                operator: 'Eq',
                value: selectedItem?.idGlobal
            }
        ],
    } as IGridFilter;

    useEffect(() => {
        if (!multipleSelect) {
            setSelectedItems([]);
        } else {
            setSelectedItem(undefined);
        }
        if (selectedItem) {
            const documentState = selectedItem.cells.find((c) => c.propertyName === "documentState")?.value as DocumentStatusType;
            setSelectedDocumentState(documentState ?? undefined);
            requestForMovementDP.getView(filterOneItem, (docs: IRequestForMovementViewDTO[], totalCount) => {
                if (totalCount === 1)
                    setSelectedItemView(docs[0]);
            })
        } else {
            setSelectedItemView(undefined);
        }
    }, [multipleSelect, selectedItem]);

    const hasOwnContractor = (selectedItemView: IRequestForMovementViewDTO | undefined) => {
        if (isAdmin) {
            return true
        }
        if (!selectedItemView || !selectedItemView.idSupplierExternalGlobal || !contractors) {
            return false;
        }
        return contractors.some(contractor =>
            contractor.idContractorGlobal === selectedItemView.idSupplierExternalGlobal
        );
    };

    return (
        <PluginWrapper>
            {checkAccessStatus(props.plugin.permission as IPermission, userContext.userPermission) && (
                <>
                    <ToolbarWrapper>
                        <DefaultDocumentsCommandsPanelV3
                            selectedItems={[selectedItems, setSelectedItems]}
                            multipleSelect={[multipleSelect, setMultipleSelect]}
                            selectedItem={[selectedItem, setSelectedItem]}
                            gridFilter={[gridFilter, dispatchGridFilter]}
                            saveFocus={[saveFocus, setSaveFocus]}
                            plugin="request_for_movement_create_plugin"
                            documentStatusType={[documentStatusType, setDocumentStatusType]}
                            selectedDocumentStatusType={[selectedDocumentState, setSelectedDocumentState]}
                            idTable={IdTableVariant.RequestForMovement}
                            dataProvider={requestForMovementDP}
                            pluginSettings={props.plugin}
                            setViewState={(vs) => setViewState(vs)}
                            mnemocode={selectedItemView?.mnemocode}
                            items={[
                                {
                                    label: "Просмотреть лог пользователя",
                                    onClick: () => selectedItem && setShowModalLog(true),
                                    disabled: selectedItem ? false : true,
                                },
                            ]}
                            advancedFeatures
                            checkLockingDocuments
                            isCancelVisible={false}
                            optionsForSearchPanel={defaultSearchOptions}
                            isRequestStatePanelVisible={true}
                            onRequestStateChange={handleRequestStateChange}
                            requestState={requestState}
                            isCreateMovementVisible={true}
                            hasOwnContractor={hasOwnContractor(selectedItemView)}

                        />
                    </ToolbarWrapper>
                </>
            )}

            <div className={styles.gridWrapper}>
                <div className={styles.masterGrid}>
                    {isSubmitting ? (
                        <Spinner />
                    ) : (
                        <DefaultGrid
                            selectedItems={selectedItems}
                            openWithEnterForEdit={{
                                pluginTabContext: "request_for_movement_create_plugin",
                                mnemocode: selectedItemView?.mnemocode,
                                selectedDocumentState,
                                
                            }}
                            documentStatus
                            searching
                            separator
                            gridId={props.gridId}
                            data={data}
                            getView={(gridFilter, callback) => {
                                requestForMovementDP.getViewParam(gridFilter, entities => {
                                    callback(entities)
                                    setSelectedItem(undefined)
                                })
                            }}
                            filter={gridFilter}
                            viewState={viewState}
                            dispatchGridFilter={dispatchGridFilter}
                            dataProvider={requestForMovementDP}
                            totalCount={totalCount}
                            plugin={props.plugin}
                            selectedItem={selectedItem}
                            multipleSelect={multipleSelect}
                            onMultipleSelect={(rows) => setSelectedItems(rows)}
                            saveFocus={[saveFocus, setSaveFocus]}
                            onSelect={(row) => {
                                setSelectedItem(row)
                                row ? pluginCtx.masterGrid.onSelectEvent(row, DocumentType.requestForMovement) : pluginCtx.masterGrid.onUnselectEvent()
                            }}
                            onSort={(i) => {
                                dispatchGridFilter({ type: "sort", payload: i.propertyName })
                            }}
                            onFilterDelete={(i) => {
                                dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })
                            }}
                            onPageNumberChange={(n) => {
                                dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })
                            }}
                            onNumberPerPageChange={(n) => {
                                dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })
                            }}

                        />
                    )}
                </div>
                {
                    <div className={styles.detailsTabView}>
                        {showDetailsTabs && detailsTabsPanel.tabs.length > 0 && selectedItem && !multipleSelect && (
                            <>
                                <div className={tabsStyles.tabsPanelWrapper}>
                                    <div id="detailsTabsPanelWrapper" style={{ position: "relative", overflow: "hidden", width: "100%" }}>
                                        <TabsPanel
                                            id="detailsTabsPanel"
                                            activeId={detailsTabsPanel.currentTab?.id}
                                            tabs={detailsTabsPanel.tabs}
                                            onActive={(id) => {
                                                dispatchDetailsTabsPanel({ type: "activate", payload: id })
                                            }}
                                        ></TabsPanel>
                                    </div>
                                </div>
                                <div className={tabsStyles.contentWrapper}>
                                    {detailsTabsPanel.tabs.map((item) => {
                                        return (
                                            <div key={item.id} className={classNames(item.id === detailsTabsPanel.currentTab?.id ? tabsStyles.contentVisible : tabsStyles.contentHidden)}>
                                                {item.view.content}
                                            </div>
                                        )
                                    })}
                                </div>
                            </>
                        )}
                    </div>
                }
                {showModalLog && <UserActionLogModal idDocumentGlobal={selectedItem?.idGlobal} onClick={() => setShowModalLog(false)} />}
            </div>
        </PluginWrapper>
    )
}
